
import AppRoutes from "./AppRoutes";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/react-query";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { PopupProvider } from "./context/PopupContext";
import { PopupManager } from "./components/popup/PopupManager";
import { PopupInitializer } from "./components/popup/PopupInitializer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <PopupProvider>
          <PopupInitializer />
          <Navbar />
          <ScrollToTop />
          {window.location.pathname !== '/' && window.location.pathname !== '' && <div className="pt-32" />}
          <AppRoutes />
          <Toaster />
          <PopupManager />
          <Footer />
        </PopupProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
